import * as React from 'react';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IStore } from '../../../../redux/IStore';
import NavigationBar from '../../components/NavigationBar';
import {Col, ControlLabel, Form, FormGroup, HelpBlock, Modal} from 'react-bootstrap';
import { actions as quoteActions, getInitialState } from '../../../../services/quote/reducer';
import {Field, formValueSelector, InjectedFormProps, reduxForm , submit } from 'redux-form';
import {
  isEmail,
  isGreaterThan,
  isPhone,
  isRequired,
  normalizeCurrency,
} from '../../../../util/validators';
import FieldFormControl from '../../../../components/FieldFormControl';
import {
  IActivities,
  IChannel,
  ICustomer,
  IIAS,
  IIOBSP,
  // IPolicyApplication,
  IProduct, IRealEstate,
} from '../../../../data/api/models';
import {IAuthState} from '../../../../services/auth/models';
import {II18nMessages} from '../../../../services/branding/models';
import {IQuoteActions, IQuoteState} from '../../../../services/quote/models';
import DeclarationQuestions from '../../components/DeclarationQuestions';
import {isUndefined} from 'util';
import {pascalCase} from '../../../../util/helpers';
import {ActivitiesField} from '../../../../components/ActivitiesField';
import Login from '../../../CustomerArea/scenes/Login';

const MAX_REVENUE = 750000;

interface IActiveFormProps extends InjectedFormProps {
  dispatch: any;
  auth: IAuthState;
  startDate: string;
  product: IProduct;
  renewal: boolean;
  channel: IChannel;
  i18n: II18nMessages;
  quote: IQuoteState;
  renderDefinition(name: string): any;
  actions: {
    quote: IQuoteActions;
  };

  revenue: number;
  activities: IActivities;
  insured: ICustomer;
  ias: IIAS;
  iobsp: IIOBSP;
  realEstate: IRealEstate;
  email: string;
  emailConfirmation: string;
}

interface IActiveFormState  {
  updateIntermediaryPercent ?: boolean;
  updateIntermediaryAmount ?: boolean;
  updateBankingPercent ?: boolean;
  updateBankingAmount ?: boolean;
  updateRealEstatePercent ?: boolean;
  updateRealEstateAmount ?: boolean;
  updateOtherPercent ?: boolean;
  updateOtherAmount ?: boolean;
}

class ActivityForm extends React.Component<IActiveFormProps, IActiveFormState> {
  public state = {
    updateIntermediaryAmount: true,
    updateIntermediaryPercent: true,
    updateBankingAmount: true,
    updateBankingPercent: true,
    updateRealEstateAmount: true,
    updateRealEstatePercent: true,
    updateOtherAmount: true,
  };

  public componentWillMount() {
    const { dispatch, change, auth } = this.props;
    dispatch(change('quotationTypes', 'Msamlin Direct'));

    if (auth.isAuthenticated) {
      dispatch(change('insured.email', auth.customer.email));
      dispatch(change('insured.emailConfirmation', auth.customer.email));
      dispatch(change('insured.firstName', auth.customer.firstName));
      dispatch(change('insured.lastName', auth.customer.lastName));
      dispatch(change('insured.companyName', auth.customer.companyName));
      dispatch(change('insured.metadata', auth.customer.metadata));
      dispatch(change('insured.address', auth.customer.address));
      dispatch(change('insured.phone', auth.customer.phone1));
    }

    dispatch(change('activities._changed', false));
  }

  public componentWillReceiveProps(nextProps) {
    const { revenue, activities, ias, iobsp, dispatch, change, auth, actions } = this.props;

    const newRevenue = nextProps.revenue;
    if (nextProps.hasOwnProperty('activities') && (revenue !== newRevenue || activities !== nextProps.activities)) {
      this.updateActivityAmounts(revenue, newRevenue, activities, nextProps.activities);
      dispatch(change('activities-changed', Date.now()));
    }

    if (activities !== nextProps.activities) {
      this.updateActivities(nextProps);
    }

    if (ias && nextProps.hasOwnProperty('ias') && ias.primary !== nextProps.ias.primary) {
      this.resetAnswersToInitialState('ias');
    }

    if (iobsp && nextProps.hasOwnProperty('iobsp') && iobsp.primary !== nextProps.iobsp.primary) {
      this.resetAnswersToInitialState('iobsp');
    }

    if (auth.isAuthenticated !== nextProps.auth.isAuthenticated && nextProps.auth.isAuthenticated) {
      actions.quote.resetExistingCustomerCheck();
      dispatch(change('insured.id', nextProps.auth.customer.id));
      dispatch(change('insured.title', nextProps.auth.customer.title));
      dispatch(change('insured.firstName', nextProps.auth.customer.firstName));
      dispatch(change('insured.lastName', nextProps.auth.customer.lastName));
      dispatch(change('insured.dob', nextProps.auth.customer.dob));
      dispatch(change('insured.email', nextProps.auth.customer.email));
      dispatch(change('insured.emailConfirmation', nextProps.auth.customer.email));
      dispatch(change('insured.address', nextProps.auth.customer.address));
      dispatch(change('insured.metadata', nextProps.auth.customer.metadata));
      dispatch(change('insured.companyName', nextProps.auth.customer.companyName));
      dispatch(change('insured.phone', nextProps.auth.customer.phone));
    }
  }

  private getActivities() {
    const activities = [
      {
        key: 'intermediary',
        name: 'activities.intermediary',
        label: 'Intermédiaire en Assurance (IAS)',
      },
      {
        key: 'banking',
        name: 'activities.banking',
        label: 'Intermédiaire en Opérations de Banque et Services de Paiements (IOBSP)',
      },
      {
        key: 'realEstate',
        name: 'activities.realEstate',
        label: 'Agent commercial en Immobilier à titre d\'activité unique',
      },
      {
        key: 'other',
        name: 'activities.other',
        label: 'Autre',
      },
    ];

    return activities;
  }

  private resetAnswersToInitialState(field: string) {
    const { dispatch, change } = this.props;
    dispatch(change(field + '.declaration', getInitialState().application[field].declaration));
  }

  private updateActivityAmounts(oldRevenue, newRevenue, oldActivities, newActivities) {
    const { dispatch, change, actions } = this.props;

    if (! oldActivities || ! newActivities) {
      return;
    }
    this.getActivities().map((activity) => {
      if (newActivities.hasOwnProperty(activity.key)) {
        const percentUpdateStateKey = 'update' + pascalCase(activity.key) + 'Percent';
        const amountUpdateStateKey = 'update' + pascalCase(activity.key) + 'Amount';

        // Percentage check
        if (oldRevenue !== newRevenue || oldActivities[activity.key].percent !== newActivities[activity.key].percent) {
          const newAmount = newRevenue * (newActivities[activity.key].percent / 100);

          if (this.state[amountUpdateStateKey] && newAmount !== oldActivities[activity.key].amount) {
            dispatch(change(
              'activities.' + activity.key + '.amount',
              newAmount,
            ));
            this.setState({ [percentUpdateStateKey]: false });
          }

          if (! this.state[amountUpdateStateKey]) {
            this.setState({ [amountUpdateStateKey]: true });
          }
        } else if (oldActivities[activity.key].amount !== newActivities[activity.key].amount) {
          // Amount check
          const newPercentage = ((newActivities[activity.key].amount / newRevenue) * 100).toFixed(2);
          if (newPercentage !== oldActivities[activity.key].percent
            && this.state[percentUpdateStateKey]) {
            dispatch(change(
              'activities.' + activity.key + '.percent',
              newPercentage,
            ));

            this.setState({ [amountUpdateStateKey]: false });
          }
          if (! this.state[percentUpdateStateKey]) {
            this.setState({ [percentUpdateStateKey]: true });
          }
        }
      }
    });

    // Reset annual gross premium to 0
    actions.quote.setAnnualGrossPremium(0);
  }

  private updateActivities(nextProps) {
    const { activities, ias, iobsp, realEstate, dispatch, change } = this.props;

    if (! activities) {
      return;
    }

    let clearDeclarations = false;

    if (activities.hasOwnProperty('intermediary')) {
      const newIASIncluded = nextProps.activities.intermediary.percent > 0;
      if (ias.included !== newIASIncluded) {
        dispatch(change('ias.included', newIASIncluded));
      }

      const newIASPrimary = nextProps.activities.intermediary.percent >= 50;
      if (ias.primary !== newIASPrimary) {
        dispatch(change('ias.primary', newIASPrimary));
      }

      if (! newIASIncluded) {
        this.clearIAS();

        clearDeclarations = true;
      }
    }

    if (activities.hasOwnProperty('banking')) {
      const newIOBSPIncluded = nextProps.activities.banking.percent > 0;
      if (iobsp.included !== newIOBSPIncluded) {
        dispatch(change('iobsp.included', newIOBSPIncluded));
      }

      const newIOBSPPrimary = nextProps.activities.banking.percent > 50;
      if (iobsp.primary !== newIOBSPPrimary) {
        dispatch(change('iobsp.primary', newIOBSPPrimary));
      }

      if (! newIOBSPIncluded) {
        this.clearIOBSP();
        clearDeclarations = true;
      }
    }

    if (activities.hasOwnProperty('realEstate')) {
      const newRealEstateIncluded = nextProps.activities.realEstate.percent > 0;
      if (realEstate.included !== newRealEstateIncluded) {
        dispatch(change('realEstate.included', newRealEstateIncluded));

        if (! newRealEstateIncluded) {
          dispatch(change('activities.declaration[1]', ''));
          clearDeclarations = true;
        }
      }
    }

    if (clearDeclarations) {
      this.clearDeclarations();
    }
  }

  private clearDeclarations() {
    const { dispatch, change } = this.props;
    dispatch(change('declaration', getInitialState().application.declaration));
  }

  private clearIAS() {
    const { dispatch, change } = this.props;
    dispatch(change('ias', getInitialState().application.ias));

    dispatch(change('declaration[9]', ''));
    dispatch(change('declaration[10]', ''));
  }

  private clearIOBSP() {
    const { dispatch, change } = this.props;
    dispatch(change('iobsp', getInitialState().application.iobsp));

    dispatch(change('declaration[11]', ''));
    dispatch(change('declaration[12]', ''));
  }

  // private sumActivityPercentages() {
  //   const { activities } = this.props;
  //
  //   if (! activities) {
  //     return 0;
  //   }
  //
  //   return ['intermediary', 'banking', 'realEstate', 'other'].reduce((total, activity) => {
  //     let value = 0;
  //     if (activities.hasOwnProperty(activity) &&
  //       activities[activity].hasOwnProperty('percent') &&
  //       activities[activity].percent !== ''
  //     ) {
  //       value = activities[activity].percent;
  //     }
  //
  //     if (value === null) {
  //       value = 0;
  //     }
  //
  //     return parseFloat(total.toString()) + parseFloat(value.toString());
  //   }, 0);
  // }

  private showRealEstateTaxExemptionQuestion() {
    return this.props.activities &&
      this.props.activities.hasOwnProperty('realEstate') &&
      parseFloat(this.props.activities.realEstate.percent) === 100;
  }

  private validateRevenue() {
    const { revenue } = this.props;

    return revenue <= MAX_REVENUE;
  }

  private validateRealEstateActivityPercentage() {
    const { activities, revenue } = this.props;
    if (!activities || !activities.hasOwnProperty('realEstate')) {
      return true;
    }

    const percent = parseInt(activities.realEstate.percent, 10);
    const amount = parseInt(activities.realEstate.amount, 10);

    const valid = (isNaN(percent) || percent === 0 || percent === 100)
      && (isNaN(amount) || amount === 0 || amount === parseInt(revenue.toString(), 10));

    return valid;
  }

  private validateRealEstateDeclaration() {
    const { activities } = this.props;
    return activities.declaration[1] !== 'true';
  }

  private areEmailsSame() {
    const { insured } = this.props;

    if (isUndefined(insured)) {
       return true;
    }

    return (! insured.email || ! insured.emailConfirmation)
      || insured.email === insured.emailConfirmation;
  }

  private customerExists() {
    const { quote } = this.props;

    // if (quote.existingCustomer.checked && quote.existingCustomer.hasCustomer) {
    //   this.setState({ showModal: true });
    // }

    return quote.existingCustomer.hasCustomer;
  }

  public render() {
    const { handleSubmit, i18n, renderDefinition, activities, auth, quote } = this.props;
    const isAuth = auth.isAuthenticated;

    const isValid = this.validateRevenue()
      && this.validateRealEstateActivityPercentage()
      && this.validateRealEstateDeclaration()
      && this.areEmailsSame();

    return (
      <div>
      <Form horizontal={true}
            onSubmit={handleSubmit}
            autoComplete="off">
        <div className="steps-container">
          <p>
            Votre activité est réglementée. Elle est soumise à des obligations, dont celle de souscrire une assurance
            RC Professionnelle et dans certains cas, une garantie financière.
            <br/>
            Avec plus de 20 ans d'expérience dans l'assurance des professions réglementées, MS Amlin connait bien vos
            attentes en terme de garanties, de tarifs, de réactivité et de gestion de sinistres.
          </p>
          <p>
            Pour faciliter vos démarches, notre équipe a développé cet outil de souscription en ligne  et vous
            accompagne si vous avez des questions.
          </p>

          <br/>
          <h3>
            Obtenez votre devis en complétant les informations ci-dessous
          </h3>

          {/* Email */}

          <FormGroup controlId={'insured.email'}>
            <Col componentClass={ControlLabel} sm={8}>
              Votre adresse électronique
            </Col>
            <Col sm={4}>
              <Field
                name={`insured.email`}
                type="email"
                component={FieldFormControl}
                onBlur={this.handleCheckExistingCustomer}
                disabled={isAuth}
                validate={[
                  isRequired,
                  isEmail,
                ]}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId={'insured.emailConfirm'}>
            <Col componentClass={ControlLabel} sm={8}>
              Veuillez confirmer votre adresse électronique
            </Col>
            <Col sm={4}>
              <Field
                name={`insured.emailConfirmation`}
                type="email"
                onBlur={this.handleCheckExistingCustomer}
                component={FieldFormControl}
                disabled={isAuth}
                validate={[
                  isRequired,
                  isEmail,
                ]}
              />
              {! this.areEmailsSame() && (
                <div className="has-error">
                  <HelpBlock>{i18n.quote.validation.emailConfirmationError}</HelpBlock>
                </div>
              )}
            </Col>
          </FormGroup>
          <FormGroup controlId={'insured.phone'}>
            <Col componentClass={ControlLabel} sm={8}>
              Numéro de téléphone
            </Col>
            <Col sm={4}>
              <Field
                name={`insured.phone`}
                component={FieldFormControl}
                validate={[]}
              />
            </Col>
          </FormGroup>

          <hr/>

          <FormGroup controlId={'revenue'}>
            <Col componentClass={ControlLabel} sm={8}>
              {renderDefinition('revenue')}
              Montant global de votre dernier chiffre d'affaires (ou montant prévisionnel si création)
            </Col>
            <Col sm={4}>
              <Field
                addOn="€"
                currency={true}
                type="inputGroup"
                name="revenue"
                normalize={normalizeCurrency}
                component={FieldFormControl}
                validate={[ isRequired, isGreaterThan(0, 'Le chiffre d\'affaires doit être supérieur à zéro') ]}
              />
            </Col>
          </FormGroup>
          {! this.validateRevenue() && (
            <div className="alert alert-danger">
              <p>
                Le chiffre d'affaires renseigné ne permet pas la réalisation d'un devis en ligne. Merci de nous
                contacter à l'adresse suivante : <a href="mailto:rcpro.france@msamlin.com">
                rcpro.france@msamlin.com</a> et nous
                reviendrons vers vous dans les meilleurs délais
              </p>
            </div>
          )}
          <hr/>

          <p>
            <strong>
              Préciser le pourcentage (%) de chiffre d’affaires pour chaque activité.
            </strong>
          </p>

          <ActivitiesField
            name={'activities-group'}
            fields={this.getActivities()}
            activities={activities}
            {...this.props}
          />

          {! this.validateRealEstateActivityPercentage() && (
            <div className="alert alert-danger">
              <p>
                Nous ne pouvons donner suite, le chiffre d’affaires de votre activité d'agent commercial en immobilier
                doit être égal à 100 % de votre activité
              </p>
            </div>
          )}

          <div className={'alert alert-normal'}>
            <p>
              <strong>
                La garantie Démarchage Bancaire et Financier vous est accordée gratuitement en
                complément des garanties IAS et/ou IOBSP.
              </strong>
            </p>
          </div>

          <hr/>

          {this.showRealEstateTaxExemptionQuestion() && (
            <div>
              <DeclarationQuestions questions={[{
                field: 'activities.declaration[1]',
                question: 'Faites-vous de la défiscalisation immobilière?',
              }]} renderDefinition={renderDefinition} />

              {! this.validateRealEstateDeclaration() && (
                <div className="alert alert-danger">
                  <p>
                    Nous ne souhaitons pas garantir cette activité.
                  </p>
                </div>
              )}
            </div>
          )}

          <NavigationBar
            hasBackButton={false}
            {...this.props}
            nextButtonDisabled={! isValid || (!auth.isAuthenticated && !quote.existingCustomer.checked)}
            onClickSubmit={this.handleSubmit}
          />
        </div>
      </Form>
        <Modal show={this.props.quote.existingCustomer.showModal} onHide={this.handleCloseModal}>
          <Modal.Header closeButton={true}>
            {this.props.quote.existingCustomer.status === ('active' || 'pending') ? (
              <Modal.Title>Connexion client</Modal.Title>
            ) : (
              <Modal.Title>Importante</Modal.Title>
            )}
          </Modal.Header>
          <Modal.Body>
            {this.props.quote.existingCustomer.status === ('active' || 'pending') && (
              <Login showHeader={false} redirectTo={'/'} embed={true}/>
            )}
            {this.props.quote.existingCustomer.status === 'new' && (
              <div className="alert">
                <p className={'red'}>
                Cette adresse de mail a déjà été utilisée lors d'un devis précédent. <br/>
                Avant de poursuivre, nous vous demandons de bien vouloir activer votre compte.<br/>
                Vous recevrez sous peu un mail qui contient toutes les instructions nécessaires.
                </p>
              </div>
            )}
          </Modal.Body>
        </Modal>
      </div>
    );
  }

  private handleCheckExistingCustomer = () => {
    const { email, emailConfirmation, actions, auth, quote } = this.props;
    if (email === '' || emailConfirmation === '') {
      return;
    }

    const isAuth = auth.isAuthenticated;
    const emailsDifferent = quote.existingCustomer.email !== '' && email !== quote.existingCustomer.email;
    if (email === emailConfirmation && !isAuth && (!quote.existingCustomer.checked || emailsDifferent)) {
      actions.quote.checkExistingCustomer(email);
    }
  }

  private handleCloseModal = () => {
    const { actions } = this.props;
    actions.quote.closeExistingCustomerModal();
  }

  private handleSubmit = () => {
    const { quote, actions, dispatch } = this.props;

    if (quote.existingCustomer.checked && quote.existingCustomer.hasCustomer) {
      actions.quote.openExistingCustomerModal();
    } else {
      dispatch(submit('quote'));
    }
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');
    return component;
  },
  connect(
    (state: IStore) => {
      const startDate = selector(state, 'startDate');
      const quotationTypes = selector(state, 'quotationTypes');
      const revenue = selector(state, 'revenue');
      const activities = selector(state, 'activities');
      const insured = selector(state, 'insured');
      const ias = selector(state, 'ias');
      const iobsp = selector(state, 'iobsp');
      const realEstate = selector(state, 'realEstate');
      const email = selector(state, 'insured.email');
      const emailConfirmation = selector(state, 'insured.emailConfirmation');

      return {
        startDate,
        quotationTypes,
        revenue,
        activities,
        insured,
        ias,
        iobsp,
        realEstate,
        email,
        emailConfirmation,
        auth: state.auth,
        quote: state.quote,
      };
    },
    (dispatch) => ({
      actions: {
        quote: bindActionCreators({ ...quoteActions }, dispatch),
      },
    }),
  ),
])(ActivityForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Activity/index.tsx